// Styles for TransactionHistory go here.
import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const StyledTransactionHistory = styled.div`
  .view-gift-card {
    &__transaction-history {
      width: 100%;
      max-width: 100%;
      border-radius: ${toRem(8)};
      background-color: ${baseVariables.color['neutral10']};

      &-header {
        border-bottom: ${toRem(1)} solid ${baseVariables.color['neutral30']};
      }

      &-info-icon {
        width: ${toRem(24)};
        height: ${toRem(24)};
        &:before {
          font-size: ${toRem(24)};
        }
      }

      &-icon {
        width: ${toRem(24)};
        height: ${toRem(24)};
        &:before {
          font-size: ${toRem(22)};
        }
      }

      &-warning-icon {
        width: ${toRem(22)};
        height: ${toRem(19)};
        color: ${baseVariables.color['alert40']};
        &:before {
          font-size: ${toRem(22)};
        }
      }

      &-item-border {
        border-bottom: ${toRem(1)} dotted ${baseVariables.color['neutral30']};
      }

      &-loader {
        height: ${toRem(24)};
      }

      &-content {
        max-height: none;
        word-break: break-word;
        @media ${baseVariables.mediaQuery.md} {
          max-height: ${toRem(558)};
          overflow: auto;
        }
        ::-webkit-scrollbar-thumb {
          background-clip: padding-box;
          border-radius: ${toRem(400)};
          background: ${baseVariables.color['neutral30']};
        }
        ::-webkit-scrollbar {
          width: ${toRem(10)};
          height: ${toRem(40)};
        }

        ::-webkit-scrollbar-track {
          margin-top: ${toRem(8)};
        }
      }
    }
  }
`;
